import { lazy } from 'react';

export const ThankYouPageLazy = lazy(() => import('./thank-you-page'));
